<template>
  <b-table :data="rows" narrowed>
    <b-table-column v-slot="{ row }" sortable field="stageName" label="Étape">
      {{ row.stageName }}
    </b-table-column>
    <b-table-column
      v-slot="{ row }"
      sortable
      field="stageStartedAtTs"
      label="Date"
      :custom-sort="sortByNumber('stageStartedAtTs')"
    >
      {{ row.stageStartedAt }}
    </b-table-column>
    <b-table-column
      v-slot="{ row }"
      sortable
      field="initialPercentage"
      label="Batterie initiale"
      :custom-sort="sortByNumber('initialPercentage')"
    >
      <span
        v-if="row.initialPercentage !== null"
        :class="initialBatteryClass(row.initialPercentage)"
      >
        {{ row.initialPercentage }} %
      </span>
      <template v-else>{{ EMPTY_VALUE }}</template>
    </b-table-column>
    <b-table-column
      v-slot="{ row }"
      sortable
      field="finalPercentage"
      label="Batterie finale"
      :custom-sort="sortByNumber('finalPercentage')"
    >
      <template v-if="row.finalPercentage !== null">{{ row.finalPercentage }} %</template>
      <template v-else>{{ EMPTY_VALUE }}</template>
    </b-table-column>
    <b-table-column
      v-slot="{ row }"
      sortable
      field="averageMotionConsumptionPerHour"
      label="Conso / h"
      :custom-sort="sortByNumber('averageMotionConsumptionPerHour')"
    >
      {{ formatRate(row.averageMotionConsumptionPerHour) }}
    </b-table-column>
    <b-table-column
      v-slot="{ row }"
      sortable
      field="averageIdleConsumptionPerHour"
      label="Conso veille / h"
      :custom-sort="sortByNumber('averageIdleConsumptionPerHour')"
    >
      {{ formatRate(row.averageIdleConsumptionPerHour) }}
    </b-table-column>
    <b-table-column
      v-slot="{ row }"
      sortable
      field="chargeCount"
      label="Recharges"
      :custom-sort="sortByNumber('chargeCount')"
    >
      {{ row.chargeCount === null ? EMPTY_VALUE : row.chargeCount }}
    </b-table-column>
    <b-table-column
      v-slot="{ row }"
      sortable
      field="averageMotionIntervalSeconds"
      label="Intervalle moyen"
      :custom-sort="sortByNumber('averageMotionIntervalSeconds')"
    >
      {{ formatInterval(row.averageMotionIntervalSeconds) }}
    </b-table-column>
  </b-table>
</template>

<script>
const EMPTY_VALUE = '—'

const INITIAL_BATTERY_TIERS = [
  { above: 90, className: 'has-text-green' },
  { above: 80, className: 'has-text-yellow' },
  { above: 70, className: 'has-text-orange' },
]

const SECONDS_PER_MINUTE = 60
const SECONDS_PER_HOUR = 60 * 60

const formatDuration = (seconds) => {
  const rounded = Math.round(seconds)

  if (rounded < SECONDS_PER_MINUTE) {
    return `${rounded} s`
  }

  if (rounded < SECONDS_PER_HOUR) {
    return `${Math.floor(rounded / SECONDS_PER_MINUTE)} min`
  }

  const hours = Math.floor(rounded / SECONDS_PER_HOUR)
  const minutes = Math.floor((rounded % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE)

  return `${hours} h ${String(minutes).padStart(2, '0')}`
}

export default {
  name: 'QueclinkTrackerStatisticsStageTable',

  props: {
    rows: {
      type: Array,
      required: true,
    },
  },

  created() {
    this.EMPTY_VALUE = EMPTY_VALUE
  },

  methods: {
    sortByNumber(field) {
      return (left, right, isAscending) => {
        if (left[field] === null || right[field] === null) {
          return (left[field] === null ? 1 : 0) - (right[field] === null ? 1 : 0)
        }

        return isAscending ? left[field] - right[field] : right[field] - left[field]
      }
    },

    initialBatteryClass(percentage) {
      return (
        INITIAL_BATTERY_TIERS.find((tier) => percentage > tier.above)?.className ?? 'has-text-red'
      )
    },

    formatRate(percentagePerHour) {
      return percentagePerHour === null ? EMPTY_VALUE : `${percentagePerHour.toFixed(1)} %`
    },

    formatInterval(seconds) {
      return seconds === null ? EMPTY_VALUE : formatDuration(seconds)
    },
  },
}
</script>
